import React from "react";
import Tradicional1 from "../assets/tradicional/linhatradicional1.jpg";
import Tradicional2 from "../assets/tradicional/linhatradicional2.jpg";
import Tradicional3 from "../assets/tradicional/linhatradicional3.jpg";
import Tradicional4 from "../assets/tradicional/linhatradicional4.jpg";
import Tradicional5 from "../assets/tradicional/linhatradicional5.jpg";
import Tradicional6 from "../assets/tradicional/linhatradicional6.jpg";
import Tradicional7 from "../assets/tradicional/linhatradicional7.jpg";
import Tradicional8 from "../assets/tradicional/linhatradicional8.jpg";
import Tradicional9 from "../assets/tradicional/linhatradicional9.jpg";
import Tradicional10 from "../assets/tradicional/linhatradicional10.jpg";
import Tradicional11 from "../assets/tradicional/linhatradicional11.jpg";
import Tradicional12 from "../assets/tradicional/linhatradicional12.jpg";
import Tradicional13 from "../assets/tradicional/linhatradicional13.jpg";
import Tradicional14 from "../assets/tradicional/linhatradicional14.jpg";
import Tradicional15 from "../assets/tradicional/linhatradicional15.jpg";
import Tradicional16 from "../assets/tradicional/linhatradicional16.jpg";
import Tradicional17 from "../assets/tradicional/linhatradicional17.jpg";
import Tradicional18 from "../assets/tradicional/linhatradicional18.jpg";
import Tradicional19 from "../assets/tradicional/linhatradicional19.jpg";
import Tradicional20 from "../assets/tradicional/linhatradicional20.jpg";
import Tradicional21 from "../assets/tradicional/linhatradicional21.jpg";
import Tradicional22 from "../assets/tradicional/linhatradicional22.jpg";
import Tradicional23 from "../assets/tradicional/linhatradicional23.jpg";
import Tradicional24 from "../assets/tradicional/linhatradicional24.jpg";
import Tradicional25 from "../assets/tradicional/linhatradicional25.jpg";
import Tradicional26 from "../assets/tradicional/linhatradicional26.jpg";
import Tradicional27 from "../assets/tradicional/linhatradicional27.jpg";
import Tradicional28 from "../assets/tradicional/linhatradicional28.jpg";
import Tradicional29 from "../assets/tradicional/linhatradicional29.jpg";
import Tradicional30 from "../assets/tradicional/linhatradicional30.jpg";
import Tradicional31 from "../assets/tradicional/linhatradicional31.jpg";
import Tradicional32 from "../assets/tradicional/linhatradicional32.jpg";
import Tradicional33 from "../assets/tradicional/linhatradicional33.jpg";
import Tradicional34 from "../assets/tradicional/linhatradicional34.jpg";
import Tradicional35 from "../assets/tradicional/linhatradicional35.jpg";
import Tradicional36 from "../assets/tradicional/linhatradicional36.jpg";
import Tradicional37 from "../assets/tradicional/linhatradicional37.jpg";
import Tradicional38 from "../assets/tradicional/linhatradicional38.jpg";
import Tradicional39 from "../assets/tradicional/linhatradicional39.jpg";
import Tradicional40 from "../assets/tradicional/linhatradicional40.jpg";
import Tradicional41 from "../assets/tradicional/linhatradicional41.jpg";
import Tradicional42 from "../assets/tradicional/linhatradicional42.jpg";
import Tradicional43 from "../assets/tradicional/linhatradicional43.jpg";
import Tradicional44 from "../assets/tradicional/linhatradicional44.jpg";
import Tradicional45 from "../assets/tradicional/linhatradicional45.jpg";
import Tradicional46 from "../assets/tradicional/linhatradicional46.jpg";
import Tradicional47 from "../assets/tradicional/linhatradicional47.jpg";
import Tradicional48 from "../assets/tradicional/linhatradicional48.jpg";
import Tradicional49 from "../assets/tradicional/linhatradicional49.jpg";
import Tradicional50 from "../assets/tradicional/linhatradicional50.jpg";
import Tradicional51 from "../assets/tradicional/linhatradicional51.jpg";
import Tradicional52 from "../assets/tradicional/linhatradicional52.jpg";
import Tradicional53 from "../assets/tradicional/linhatradicional53.jpg";
import Tradicional54 from "../assets/tradicional/linhatradicional54.jpg";
import Tradicional55 from "../assets/tradicional/linhatradicional55.jpg";
import Tradicional56 from "../assets/tradicional/linhatradicional56.jpg";
import Tradicional57 from "../assets/tradicional/linhatradicional57.jpg";
import Tradicional58 from "../assets/tradicional/linhatradicional58.jpg";
import Tradicional59 from "../assets/tradicional/linhatradicional59.jpg";
import Tradicional60 from "../assets/tradicional/linhatradicional60.jpg";
import Tradicional61 from "../assets/tradicional/linhatradicional61.jpg";
import Tradicional62 from "../assets/tradicional/linhatradicional62.jpg";
import Tradicional63 from "../assets/tradicional/linhatradicional63.jpg";
import Tradicional64 from "../assets/tradicional/linhatradicional65.jpg";
import Tradicional65 from "../assets/tradicional/linhatradicional66.jpg";
import Tradicional66 from "../assets/tradicional/linhatradicional67.jpg";
import Tradicional67 from "../assets/tradicional/linhatradicional68.jpg";
import Tradicional68 from "../assets/tradicional/linhatradicional69.jpg";
import Tradicional69 from "../assets/tradicional/linhatradicional70.jpg";
import Tradicional70 from "../assets/tradicional/linhatradicional71.jpg";
import Tradicional71 from "../assets/tradicional/linhatradicional72.jpg";
import Tradicional72 from "../assets/tradicional/linhatradicional73.jpg";
import Tradicional73 from "../assets/tradicional/linhatradicional74.jpg";
import Tradicional74 from "../assets/tradicional/linhatradicional75.jpg";
import Tradicional75 from "../assets/tradicional/linhatradicional76.jpg";
import Tradicional76 from "../assets/tradicional/linhatradicional77.jpg";
import Tradicional77 from "../assets/tradicional/linhatradicional78.jpg";
import Tradicional78 from "../assets/tradicional/linhatradicional79.jpg";
import Tradicional79 from "../assets/tradicional/linhatradicional80.jpg";
import Tradicional80 from "../assets/tradicional/linhatradicional81.jpg";
import Tradicional81 from "../assets/tradicional/linhatradicional82.jpg";
import Tradicional82 from "../assets/tradicional/linhatradicional83.jpg";
import Tradicional83 from "../assets/tradicional/linhatradicional84.jpg";
import Tradicional84 from "../assets/tradicional/Canecão_Medida_alto.png";
import Tradicional85 from "../assets/tradicional/FormaParaCuscuz.png";

import { Fade, Reveal } from "react-reveal";

const Products = () => {
  const products = PRODUCTS.products;

  return (
    <div
      className="
                grid grid-cols-1 gap-x-36 gap-y-14 mx-10 items-center 
                justify-center 
                sm:grid-cols-1 sm:mx-10 
                md:mx-10 md:grid-cols-2
                lg:mx-28 lg:grid-cols-3 lg:gap-x-10 
            "
    >
      {products.map((item, index) => (
        <Reveal key={index}>
          <Fade bottom big>
            <a href={item.name1}>
              <div className="h-full">
                <button className="bg-white w-full h-full drop-shadow-2xl rounded-md transition ease-in-out hover:-translate-y-1 hover:scale-110">
                  <div className="w-full p-7 items-center flex flex-col">
                    <img
                      src={item.image_url}
                      alt=""
                      className="w-full h-48 object-contain"
                    />
                    <div className="w-full mt-10 flex flex-col items-center h-full">
                      <span className="font-poppins font-bold text-preto text-2xl p-1 -mb-2"></span>
                      <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                        {item.name}
                      </span>
                      <span className="font-poppins font-light text-base text-preto">
                        {item.description || "\u00A0"}
                      </span>
                    </div>
                  </div>
                </button>
              </div>
            </a>
          </Fade>
        </Reveal>
      ))}
    </div>
  );
};

export default Products;

const PRODUCTS = {
  products: [
    {
      name: "Aquecedor P/ Arroz",
      name1: "Aquecedor P Arroz",
      image_url: Tradicional1,
    },
    {
      name: "Assadeira Oblonga",
      name1: "Assadeira Oblonga",
      image_url: Tradicional2,
    },
    {
      name: "Assadeira P/ Frango",
      name1: "Assadeira P Frango",
      image_url: Tradicional3,
    },
    {
      name: "Assadeira P/ Pizza",
      name1: "Assadeira P Pizza",
      image_url: Tradicional4,
    },
    {
      name: "Assadeira Redonda",
      name1: "Assadeira Redonda",
      image_url: Tradicional5,
    },
    {
      name: "Assadeira Redonda Alta",
      name1: "Assadeira Redonda Alta",
      image_url: Tradicional6,
    },
    {
      name: "Assadeira Retangular Alta",
      name1: "Assadeira Retangular Alta",
      image_url: Tradicional7,
    },
    {
      name: "Assadeira Retangular C/ Grelha",
      name1: "Assadeira Retangular C Grelha",
      image_url: Tradicional8,
    },
    {
      name: "Assadeira Retangular Baixa",
      name1: "Assadeira Retangular Baixa",
      image_url: Tradicional9,
    },
    {
      name: "Bacia Reforçada",
      name1: "Bacia Reforcada",
      image_url: Tradicional10,
    },
    {
      name: "Balde Fosco",
      name1: "Balde Fosco",
      image_url: Tradicional11,
    },
    {
      name: "Balde P/ Gelo",
      name1: "Balde P Gelo",
      image_url: Tradicional12,
    },
    {
      name: "Bandeja Luxo",
      name1: "Bandeja Luxo",
      image_url: Tradicional13,
    },
    {
      name: "Bandeja Retangular",
      name1: "Bandeja Retangular",
      image_url: Tradicional14,
    },
    {
      name: "Bule Chinês Luxo",
      name1: "Bule Chines Luxo",
      image_url: Tradicional15,
    },
    {
      name: "Bule Cônico Polido",
      name1: "Bule Conico Polido",
      image_url: Tradicional16,
    },
    {
      name: "Caçarola Especial C/ Alça",
      name1: "Cacarola Especial C Alca",
      image_url: Tradicional17,
    },
    {
      name: "Caçarola Especial C/ Cabo",
      name1: "Cacarola Especial C Cabo",
      image_url: Tradicional18,
    },
    {
      name: "Caçarola Japi",
      name1: "Cacarola Japi",
      image_url: Tradicional19,
    },
    {
      name: "Cafeteira inteiriça",
      name1: "Cafeteira inteirica",
      image_url: Tradicional20,
    },
    {
      name: "Cafeteira  Marlita",
      name1: "Cafeteira  Marlita",
      image_url: Tradicional21,
    },
    {
      name: "Caldeirão Bojudo",
      name1: "Caldeirao Bojudo",
      image_url: Tradicional22,
    },
    {
      name: "Caneca Extra",
      name1: "Caneca Extra",
      image_url: Tradicional23,
    },
    {
      name: "Caneca Fosca",
      name1: "Caneca Fosca",
      image_url: Tradicional24,
    },
    {
      name: "Caneca P/ Chopp",
      name1: "Caneca P Chopp",
      image_url: Tradicional25,
    },
    {
      name: "Canecão Especial",
      name1: "Canecao Especial",
      image_url: Tradicional26,
    },
    {
      name: "Canecão medida",
      name1: "Canecao medida",
      image_url: Tradicional27,
    },
    {
      name: "Canecão Medida Alto",
      name1: "Canecao Medida Alto",
      image_url: Tradicional84,
    },
    {
      name: "Chaleira Chinesa",
      name1: "Chaleira Chinesa",
      image_url: Tradicional29,
    },
    {
      name: "Chaleira Polida",
      name1: "Chaleira Polida",
      image_url: Tradicional30,
    },
    {
      name: "Comedouro P/ Cães",
      name1: "Comedouro P Caes",
      image_url: Tradicional31,
    },
    {
      name: "Concha Extra",
      name1: "Concha Extra",
      image_url: Tradicional32,
    },
    {
      name: "Concha Extra C/ Cabo Baquelite",
      name1: "Concha Extra C Cabo Baquelite",
      image_url: Tradicional33,
    },
    {
      name: "Concha Super Forte",
      name1: "Concha Super Forte",
      image_url: Tradicional34,
    },
    {
      name: "Copo Extra",
      name1: "Copo Extra",
      image_url: Tradicional35,
    },
    {
      name: "Copo Extra C /Asa",
      name1: "Copo Extra C Asa",
      image_url: Tradicional36,
    },
    {
      name: "Copo Extra Infantil",
      name1: "Copo Extra Infantil",
      image_url: Tradicional37,
    },
    {
      name: "Escorredor P/ Arroz",
      name1: "Escorredor P Arroz",
      image_url: Tradicional38,
    },
    {
      name: "Espumadeira Extra",
      name1: "Espumadeira Extra",
      image_url: Tradicional39,
    },
    {
      name: "Espumadeira Extra C/ Cabo Baquelite",
      name1: "Espumadeira Extra C Cabo Baquelite",
      image_url: Tradicional40,
    },
    {
      name: "Espumadeira Super Forte",
      name1: "Espumadeira Super Forte",
      image_url: Tradicional41,
    },
    {
      name: "Fervedor C/ Apito",
      name1: "Fervedor C Apito",
      image_url: Tradicional42,
    },
    {
      name: "Fervedor Inderramável",
      name1: "Fervedor Inderramavel",
      image_url: Tradicional43,
    },
    {
      name: "Fervedor Tradicional",
      name1: "Fervedor Tradicional",
      image_url: Tradicional44,
    },
    {
      name: "Filtra Óleo",
      name1: "Filtra Oleo",
      image_url: Tradicional45,
    },
    {
      name: "Forma Banho Maria",
      name1: "Forma Banho Maria",
      image_url: Tradicional46,
    },
    {
      name: "Forma Coracão",
      name1: "Forma Coracao",
      image_url: Tradicional47,
    },
    {
      name: "Forma de Pudim C/ Tampa",
      name1: "Forma de Pudim C Tampa",
      image_url: Tradicional48,
    },
    {
      name: "Forma P/ Bolo Dupla",
      name1: "Forma P Bolo Dupla",
      image_url: Tradicional49,
    },
    {
      name: "Forma P/ Bolo S/ Tampa",
      name1: "Forma P Bolo S Tampa",
      image_url: Tradicional50,
    },
    {
      name: "Forma P/ Cuscuz",
      name1: "Forma P Cuscuz",
      image_url: Tradicional51,
    },
    {
      name: "Forma P/ Cuscuz Conjugada",
      name1: "Forma P Cuscuz Conjugada",
      image_url: Tradicional52,
    },
    {
      name: "Forma P/ Cuscuz Individual C/ Cabo",
      name1: "Forma P Cuscuz Individual",
      image_url: Tradicional53,
    },
    {
      name: "Forma P/ Cuscuz Individual C/ Alça",
      name1: "Forma P Cuscuz Individual C Alca",
      image_url: Tradicional85,
    },
    {
      name: "Forma P/ Empada",
      name1: "Forma P Empada",
      image_url: Tradicional54,
    },
    {
      name: "Forma P/ Pão",
      name1: "Forma P Pao",
      image_url: Tradicional55,
    },
    {
      name: "Forma P/ Pudim Polida",
      name1: "Forma P Pudim Polida",
      image_url: Tradicional56,
    },
    {
      name: "Forma P/ Queijo",
      name1: "Forma P Queijo",
      image_url: Tradicional57,
    },
    {
      name: "Forma P/ Torta",
      name1: "Forma P Torta",
      image_url: Tradicional58,
    },
    {
      name: "Funil Fosco",
      name1: "Funil Fosco",
      image_url: Tradicional59,
    },
    {
      name: "Jarra Bojuda",
      name1: "Jarra Bojuda",
      image_url: Tradicional60,
    },
    {
      name: "Jarra Luxo C/ Tampa",
      name1: "Jarra Luxo C Tampa",
      image_url: Tradicional61,
    },
    {
      name: "Jarra Reta C/ Tampa",
      name1: "Jarra Reta C Tampa",
      image_url: Tradicional62,
    },
    {
      name: "Latão P/ Gordura",
      name1: "Latao P Gordura",
      image_url: Tradicional63,
    },
    {
      name: "Latão P/ Leite",
      name1: "Latao P Leite",
      image_url: Tradicional64,
    },
    {
      name: "Marmita Operária",
      name1: "Marmita Operaria",
      image_url: Tradicional65,
    },
    {
      name: "Marmita Polida",
      name1: "Marmita Polida",
      image_url: Tradicional66,
    },
    {
      name: "Marmita Térmica",
      name1: "Marmita Termica",
      image_url: Tradicional67,
    },
    {
      name: "Moringa Boca Larga",
      name1: "Moringa Boca Larga",
      image_url: Tradicional68,
    },
    {
      name: "Moringa Boca Larga C/ Cabo",
      name1: "Moringa Boca Larga C Cabo",
      image_url: Tradicional69,
    },
    {
      name: "Moringa Polida",
      name1: "Moringa Polida",
      image_url: Tradicional70,
    },
    {
      name: "Passador P/ Macarrão",
      name1: "Passador P Macarrao",
      image_url: Tradicional71,
    },
    {
      name: "Pipoqueira Polida",
      name1: "Pipoqueira Polida",
      image_url: Tradicional72,
    },
    {
      name: "Porta Garrafa de Cerveja",
      name1: "Porta Garrafa de Cerveja",
      image_url: Tradicional73,
    },
    {
      name: "Porta Lata",
      name1: "Porta Lata",
      image_url: Tradicional74,
    },
    {
      name: "Porta Latão",
      name1: "Porta Latao",
      image_url: Tradicional75,
    },
    {
      name: "Porta Litrão de Cerveja",
      name1: "Porta Litrao de Cerveja",
      image_url: Tradicional76,
    },
    {
      name: "Prato Fosco",
      name1: "Prato Fosco",
      image_url: Tradicional77,
    },
    {
      name: "Púcaro",
      name1: "Pucaro",
      image_url: Tradicional78,
    },
    {
      name: "Taça Tulipa",
      name1: "Taca Tulipa",
      image_url: Tradicional79,
    },
    {
      name: "Tacho Fosco",
      name1: "Tacho Fosco",
      image_url: Tradicional80,
    },
    {
      name: "Tampa Avulsa",
      name1: "Tampa Avulsa",
      image_url: Tradicional81,
    },
    {
      name: "Tigela Polida",
      name1: "Tigela Polida",
      image_url: Tradicional82,
    },
    {
      name: "Urinol",
      name1: "Urinol",
      image_url: Tradicional83,
    },
  ],
};
